const appEnv = process.env.REACT_APP_ENVIRONMENT as 'dev' | 'prod';
const hostname = process.env.REACT_APP_HOSTNAME;
const aceApi = process.env.REACT_APP_ACE_API;
const userEndpoint = process.env.REACT_APP_USER_API;
const myAccountApi = process.env.REACT_APP_MY_ACCOUNT_API;
const avatarApi = process.env.REACT_APP_AVATAR_API;
const accountApi = process.env.REACT_APP_ACCOUNT_API;
const baseSiteUrl = process.env.REACT_APP_SITE_URL;

export { appEnv, hostname, aceApi, userEndpoint, myAccountApi, avatarApi, accountApi, baseSiteUrl };
